import { ENV } from '@shared/config/env'
import { TgAppShell } from './app/TgAppShell'
import { WebAppShell } from './app/WebAppShell'
import './App.css'
import './index.css'

function App() {
  return ENV.IS_WEB ? <WebAppShell /> : <TgAppShell />
}

export default App
